import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../shared/services/httpclient.service";
import { MergeToGroupRequest } from "./report-services/merge-to-group-request";
import { PrintReportManualRequest } from "../student/student-digital-id-registration/shared/PrintReportManualRequest";

@Injectable()
export class ReportService {
	constructor(private httpclientService: HttpclientService) {}

	ReportTableGetList() {
		var postResult$ = new Subject();
		var url = "Report/ReportTableGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ReportImport(Directory, SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/ReportImport?Directory=" + Directory + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ReportExport(ReportID) {
		var postResult$ = new Subject();
		var url = "Report/ReportExport?ReportID=" + ReportID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	HomeroomGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/HomeroomGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PenaltyGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/PenaltyGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	InfractionGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/InfractionGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	InstructorGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/InstructorGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
	StatusGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/StatusGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ScanGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/ScanGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
	PersonGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/PersonGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	SemesterGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/SemesterGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	DayGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/DayGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
	MealSubsidyGetList() {
		var postResult$ = new Subject();
		var url = "Report/MealSubsidyGetList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
	ScanStationGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/ScanStationGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	EntryTypeGetList() {
		var postResult$ = new Subject();
		var url = "Report/EntryTypeGetList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	TimeScanTypeGetList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/TimeScanTypeGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	AttendanceStatusGetList() {
		var postResult$ = new Subject();
		var url = "Report/AttendanceStatusGetList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ExcuseGetList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/ExcuseGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	GradesGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/GradesGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
	MealGetList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/MealGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	AcademyGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/AcademyGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PeriodGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/PeriodGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	GroupGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Report/GroupGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PrintByCSVReportID(reportID, params, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/PrintByCSVReportID?ReportID=" + reportID + "&strParam=" + params + "&schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	Print(reportID, params, schoolID, ReportOutputType) {
		var postResult$ = new Subject();
		var url = "Report/PrintByReportID?ReportID=" + reportID + "&strParam=" + params + "&schoolID=" + schoolID + "&ReportOutputType=" + ReportOutputType;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PrintReportManual(parms: PrintReportManualRequest) {
		var postResult$ = new Subject();
		var url = "Report/PrintReportManual";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	BookSubjectGetList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/BookSubjectGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	BookTitleGetList(BookSubjectID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/BookTitleGetList?BookSubjectID=" + BookSubjectID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	BookStatusGetList() {
		var postResult$ = new Subject();
		var url = "Report/BookStatusGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ImageLogoGetList(ApplicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/ImageLogoGetList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	FacilitySelectList(ApplicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/FacilitySelectList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PointsCategoryTypeGetList() {
		var postResult$ = new Subject();
		var url = "Report/PointsCategoryTypeGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PointsCategoryGetList(PointsCategoryTypeID) {
		var postResult$ = new Subject();
		var url = "Report/PointsCategoryGetList?PointsCategoryTypeID=" + PointsCategoryTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	PointsItemGetList(PointsCategoryTypeID, PointsCategoryID) {
		var postResult$ = new Subject();
		var url = "Report/PointsItemGetList?PointsCategoryTypeID=" + PointsCategoryTypeID + "&PointsCategoryID=" + PointsCategoryID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	MergeToGroupSelectInfo(parms: MergeToGroupRequest) {
		var postResult$ = new Subject();
		var url = "Report/MergeToGroupSelectInfo";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	MsVisitorTypeSelectList() {
		var postResult$ = new Subject();
		var url = "Report/MsVisitorTypeSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	MsVisitorStatusSelectList() {
		var postResult$ = new Subject();
		var url = "Report/MsVisitorStatusSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	MsVisitorPassDetailStatusSelectList() {
		var postResult$ = new Subject();
		var url = "Report/MsVisitorPassDetailStatusSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	MsVisitorPersonSelectByFacility(FacilityID) {
		var postResult$ = new Subject();
		var url = "Report/MsVisitorPersonSelectByFacility?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	FacilityLocationGetListByFacility(FacilityID) {
		var postResult$ = new Subject();
		var url = "Report/FacilityLocationGetListByFacility?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ScanAccessResultGetList() {
		var postResult$ = new Subject();
		var url = "Report/ScanAccessResultGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ScanAccessModeGetList() {
		var postResult$ = new Subject();
		var url = "Report/ScanAccessModeGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	ScanExitResultGetList() {
		var postResult$ = new Subject();
		var url = "Report/ScanExitResultGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	EventScanTypeGetList(ApplicationItemID: string, SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/EventScanTypeGetList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	EventDescriptionSelectListRpt(SchoolID: number, StartDate: string, EndDate: string) {
		var postResult$ = new Subject();
		var url = "Report/EventDescriptionSelectListRpt?SchoolID=" + SchoolID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	BusGetList() {
		var postResult$ = new Subject();
		var url = "Report/BusGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	BusRouteTypeGetList() {
		var postResult$ = new Subject();
		var url = "Report/BusRouteTypeGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
}
